import { TMkResort } from '@search/services/searchTypes'
import { MkApiContext, TMkStep } from '@typescript'
import {
  IMkBookDraft,
  IMkBookingError,
  IMkAnyBookField,
  MkBookAction,
  EMkBookAction,
  IMkBookTimerData,
  TMkAvailableSuite,
  EMkBookStepName,
  IMkTripSummary,
  UpdateDatesStepContentPayload,
} from '../types'

// Action Creators
export const setBookDraft = (bookDraft: IMkBookDraft): MkBookAction => ({
  type: EMkBookAction.SET_BOOK_DRAFT,
  payload: bookDraft,
})

export const updateField = (step: TMkStep, fieldName: string, fieldValue: IMkAnyBookField['value'], fieldType: string): MkBookAction => ({
  type: EMkBookAction.UPDATE_FIELD,
  payload: {
    stepName: step.name as EMkBookStepName,
    fieldName,
    fieldValue,
    fieldType,
  },
})

export const setError = (error: IMkBookingError): MkBookAction => ({
  type: EMkBookAction.SET_ERROR,
  payload: error,
})

export const clearError = (): MkBookAction => ({
  type: EMkBookAction.CLEAR_ERROR,
})

export const setLoading = (isLoading: boolean): MkBookAction => ({
  type: EMkBookAction.SET_LOADING,
  payload: isLoading,
})

export const initBooking = (params: { resort: TMkResort; suite: TMkAvailableSuite; checkInDate: string; checkOutDate: string }): MkBookAction => ({
  type: EMkBookAction.INIT_BOOKING,
  payload: params,
})

export const clearBookingError = (): MkBookAction => ({
  type: EMkBookAction.CLEAR_ERROR,
})

export const setTimerData = (timerData: IMkBookTimerData): MkBookAction => ({
  type: EMkBookAction.SET_TIMER_DATA,
  payload: timerData,
})

export const clearTimerData = (): MkBookAction => ({
  type: EMkBookAction.CLEAR_TIMER_DATA,
})

export const setOriginalTripSummary = (tripSummary: IMkTripSummary): MkBookAction => ({
  type: EMkBookAction.SET_ORIGINAL_TRIP_SUMMARY,
  payload: tripSummary,
})

export const setApiContext = (context: MkApiContext): MkBookAction => ({
  type: EMkBookAction.SET_API_CONTEXT,
  payload: context,
})

export const setRequiresAdditionalPayment = (requiresAdditionalPayment: boolean): MkBookAction => ({
  type: EMkBookAction.SET_REQUIRES_ADDITIONAL_PAYMENT,
  payload: requiresAdditionalPayment,
})

export const updateDatesStepContent = (dates: UpdateDatesStepContentPayload): MkBookAction => ({
  type: EMkBookAction.UPDATE_DATES_STEP_CONTENT,
  payload: dates,
})

export const setHasUpdatedModifySteps = (hasUpdatedModifySteps: boolean): MkBookAction => ({
  type: EMkBookAction.SET_HAS_UPDATED_MODIFY_STEPS,
  payload: hasUpdatedModifySteps,
})
